export default __webpack_public_path__ + "static/media/rental-counter-mobile-au.ac4377ff.jpeg";